import { QueryClient } from "@tanstack/react-query";
import ms from "ms";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 3,
			structuralSharing: false,

			// cacheTime controls how long to keep the data in the Tanstack Query cache. 5 minutes is also the default when it's not defined.
			// staleTime controls how long cached data is considered non-stale (0 means it's considered stale immediately after resolving it). 0 is also the default when it's not defined.
			// The effect of this is that when a component renders, it receives the cached data first and then triggers a fetch to get the new data.
			// This allows rendering of the old data first while the fresh data is fetched. This provides a better experience when the user is moving through the application quickly,
			// e.g. they go into a classroom and then immediately go back to the home screen, this allows the home screen to load quickly as it reuses the previous data immediately while making a fetch for
			// new data.
			cacheTime: ms("5m"),
			staleTime: 0,
		},
	},
});
